import { Map as IMap } from 'immutable';
import {
    genericButtonClickedSegmentData, genericCartSegmentData,
    linkClickedSegmentData, PDPItemSegmentData, greetingViewedSegmentData
} from './segmentSelectors';


export const TRACK_EXTERNAL_LINK_CLICK = '@@storefront/TRACK_EXTERNAL_LINK_CLICK';
export const TRACK_BUTTON_CLICK = '@@storefront/TRACK_BUTTON_CLICK';
export const TRACK_PURCHASE_TYPE = '@@storefront/TRACK_PURCHASE_TYPE';
export const TRACK_DELIVERY_METHOD = '@@storefront/TRACK_DELIVERY_METHOD';
export const TRACK_HEADER_FOOTER_CLICK = '@@storefront/TRACK_HEADER_FOOTER_CLICK';
export const TRACK_CURRENCY_LANGUAGE_CHANGE = '@@storefront/TRACK_CURRENCY_LANGUAGE_CHANGE';
export const TRACK_CURRENCY_CHANGE = '@@storefront/TRACK_CURRENCY_CHANGE';
export const TRACK_GENRIC_CART_EVENT = '@@storefront/TRACK_GENRIC_CART_EVENT';
export const TRACK_ADD_TO_CART = '@@storefront/TRACK_ADD_TO_CART';
export const SET_LAST_PURCHASE_TYPE = '@@storefront/SET_LAST_PURCHASE_TYPE';
export const SET_LAST_CARD_TYPE = '@@storefront/SET_LAST_CARD_TYPE';
export const TRACK_GREETING_VIEWED = '@@storefront/TRACK_GREETING_VIEWED';


const purchaseTypeReducer = (state = IMap({}), action) => {
    switch (action.type) {
        case TRACK_PURCHASE_TYPE: {
            const purchaseTypeStatusData = action.purchaseType;
            return state.set('selectedPurchaseType', purchaseTypeStatusData);
        }
        case TRACK_DELIVERY_METHOD: {
            const deliveryMethodStatusData = action.deliveryMethod;
            return state.set('selectedDeliveryMethod', deliveryMethodStatusData);
        }
        case SET_LAST_PURCHASE_TYPE: {
            return state.set('lastPurchaseType', action.payload);
        }
        case SET_LAST_CARD_TYPE: {
            return state.set('lastCardType', action.payload);
        }
        default:
    }
    return state;
};


export function trackExternalLinkClick(eventData) {
    return {
        type: TRACK_EXTERNAL_LINK_CLICK,
        meta: {
            segment: {
                eventAction: 'External Link Clicked',
                eventData
            }
        }
    };
}

export function trackHeaderFooterClick(title, eventData) {
    return {
        type: TRACK_HEADER_FOOTER_CLICK,
        meta: {
            segment: {
                eventAction: title,
                eventData: linkClickedSegmentData(eventData)
            }
        }
    };
}
export const trackButtonClick = (buttonTitleName, destinationRoute, parent) => ({
    type: TRACK_BUTTON_CLICK,
    buttonTitleName,
    destinationRoute,
    parent,
    meta: {
        segment: {
            eventAction: 'Button Click',
            eventData: genericButtonClickedSegmentData(buttonTitleName, destinationRoute, parent)
        }
    }
});

export const trackGreetingViewed = context => ({
    type: TRACK_GREETING_VIEWED,
    meta: {
        segment: {
            eventAction: 'Greeting Viewed',
            eventData: greetingViewedSegmentData(context)
        }
    }
});


export const saveSelectedPurchaseType = purchaseType => ({
    type: TRACK_PURCHASE_TYPE,
    purchaseType
});

export const saveSelectedDeliveryMethod = deliveryMethod => ({
    type: TRACK_DELIVERY_METHOD,
    deliveryMethod
});


export const trackCurrencyLanguageChange = eventData => ({
    type: TRACK_CURRENCY_LANGUAGE_CHANGE,
    meta: {
        segment: {
            eventAction: 'Currency Language Selector',
            eventData
        }
    }
});


export const trackCurrencyChange = eventData => ({
    type: TRACK_CURRENCY_CHANGE,
    meta: {
        segment: {
            eventAction: 'Dropdown Selector',
            eventData
        }
    }
});

export const trackGenericCartSegment = (items, additionalInfo, segmentEventName) => ({
    type: TRACK_GENRIC_CART_EVENT,
    meta: {
        segment: {
            eventAction: segmentEventName,
            eventData: genericCartSegmentData(items, additionalInfo)
        }
    }
});

export const trackAddToCart = (segmentActionName, currencyCode, items, additionalInfo) => ({
    type: TRACK_ADD_TO_CART,
    meta: {
        segment: {
            eventAction: segmentActionName,
            eventData: PDPItemSegmentData(items, currencyCode, additionalInfo)
        }
    }
});



export const setLastPurchaseType = purchaseType => ({
    type: SET_LAST_PURCHASE_TYPE,
    payload: purchaseType
});

export const setLastCardType = cardType => ({
    type: SET_LAST_CARD_TYPE,
    payload: cardType
});


export default purchaseTypeReducer;
